/***
**Module Name: term and condtions
 **File Name :  Terms.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains Terms and condition details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";

//  import "../../src/assets/css/style.css"

import * as Config from "./../constants/Config";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import ReactHtmlParser from 'react-html-parser';
import { useNavigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import InsideHeader from "../components/InnerHeader/Header";
import axios from "axios";
import moment from "moment";
import LandingHeader from "../components/LandingHeader/Header";
let { lambda, appname } = window.app;

const Terms = () => {
    const navigate = useNavigate();

    const [config, setConfig] = useState({});


    useEffect(() => {
        if (localStorage.getItem("token")) {
            clientActivity()
        }

        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);
    console.log('localStorage.getItem("token")', localStorage.getItem("token"))

    if (config.common && config.common.imagesCDN) {
        var img = config.common.imagesCDN;
    }

    const clientActivity = () => {
        let path = window.location.pathname.split("/");

        var presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": 'TERMSANDCONDITIONS',
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        let urlLink;
        if (localStorage.getItem("previousid")) {
            urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
        } else {
            urlLink = lambda + '/activity?appname=' + appname
        }

        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response.data.statusCode === 200) {
                    localStorage.setItem("previousid", response.data.result)
                }
            });
    }
    function handleClose() {
        if (localStorage.getItem("token")) {
            navigate(-1)
        }
        else {
            navigate("/");
        }
    }

    const { menus } = useContext(contentContext)



    return (
        <>
            {localStorage.getItem("token") ? <InsideHeader /> : <LandingHeader menus={menus} />}


            <div className="container">
                <div className="terms-page">
                    <div className="terms-header">
                        {menus && menus.length > 0 && menus.map(function (item, i) {
                            return (
                                item.menuid === 100006 ? <div className="terms-cls-wrapper" key={i}>{ReactHtmlParser(item.content)}</div> : ""
                            )
                        })}
                    </div>
                </div>
            </div>

            <Footer menus={menus} />


        </>
    );
};

export default Terms;
